export default "__VITE_ASSET__6b430442__"